import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import moment from 'moment';
import Base from '../js/base';
import Utils from '../js/utils';
import Hh from '../js/huyhieu';
export default (function (props, _ref) {
  var $ = _ref.$,
      $on = _ref.$on,
      $f7 = _ref.$f7;
  var page_name = 'huyhieu-home';
  var pn = "div[data-name=\"".concat(page_name, "\"]"); //Xem lịch sự ví của các tháng trước

  var viewPrevMonths = function viewPrevMonths() {
    Base.app.dialog.prompt('Điền năm-tháng bạn muốn xem theo định dạng (YYYY-MM ví dụ: 2022-02).<br/>Để trống để xem tháng hiện tại.', function (month) {
      if (month === '') get(moment().format('YYYY-MM'));else get(month);
    });
    $(pn + ' .block-zero-huyhieu').addClass('display-none');
    $(pn + ' .block-non-exchangable').addClass('display-none');
    $(pn + ' .block-exchangable').addClass('display-none');
    $(pn + ' .block-category').addClass('display-none'); //Bảng danh sách huy hiệu tặng cho tổ

    $(pn + ' .block-category table tbody').html('');
  };

  var get = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(month) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Hh.getWallet(month);

            case 2:
              if (!(Hh.myWallet === null || Hh.myWallet.rows.length === 0 && Hh.myWallet.group_giving_rows.length === 0)) {
                _context.next = 5;
                break;
              }

              //Hiển thị thông báo không có huy hiệu nào
              $(pn + ' .block-zero-huyhieu').removeClass('display-none');
              return _context.abrupt("return");

            case 5:
              //Hiển thị các loại huy hiệu có trong ví
              Hh.myWallet.rows.forEach(function (row) {
                //Kiểm tra exchangable
                if (row.is_exchangable === null) {
                  //Số huy hiệu không thể quy đổi
                  $(pn + ' .block-non-exchangable').removeClass('display-none');
                  $(pn + " .block-non-exchangable table tr[data-idhuyhieu=\"".concat(row.id_huyhieu, "\"]")).removeClass('display-none');
                  $(pn + " .block-non-exchangable table tr[data-idhuyhieu=\"".concat(row.id_huyhieu, "\"] td:nth-child(2)")).text(row.qty);
                } else {
                  //Số huy hiệu được tặng/có thể quy đổi
                  $(pn + ' .block-exchangable').removeClass('display-none');
                  $(pn + " .block-exchangable table tr[data-idhuyhieu=\"".concat(row.id_huyhieu, "\"]")).removeClass('display-none');
                  $(pn + " .block-exchangable table tr[data-idhuyhieu=\"".concat(row.id_huyhieu, "\"] td:nth-child(2)")).text(row.qty);
                }
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function get(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  $on('pageAfterIn', function () {
    return get(moment().format('YYYY-MM'));
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="${page_name}">
  <div class="page-content">

    <div class="block block-strong text-align-center block-zero-huyhieu display-none">
      Bạn chưa có điểm
    </div>

    <div class="card data-table margin-half block-non-exchangable display-none">
      <div class="block-title">Điểm không được quy đổi</div>
      <table>
        <tbody>
          <tr data-idhuyhieu="1" class="display-none">
            <td>Số lượng</td><td class="text-align-right">0</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="card data-table margin-half block-exchangable display-none">
      <div class="card-header">Điểm có thể quy đổi</div>
      <table>
        <tbody>
          <tr data-idhuyhieu="1" class="display-none">
            <td>Số lượng</td><td class="text-align-right">0</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="block text-align-center">
      <a @click="${viewPrevMonths}">Xem các tháng trước</a>
    </div>

  </div>
</div>
`
    }
    ;
});